import React from 'react'
import Customer from '../code/models/Customer';
import Api_Config from '../code/api/ApiConfig';
import AuthAdminUserModel from "../code/models/AuthAdminUserModel";
import ApiAwardReport from "../code/api/ApiAwardReport";
import Auth from "../code/auth/Auth";
import BidPeriodAwardReportInfo from "../code/models/BidPeriodAwardReportInfo";
import '../css/customerinfoawardreport.css'

interface ICustomerInfoAwardReport {
    customer: Customer;
    currentUser: AuthAdminUserModel;
}

export default function CustomerInfoAwardReport({ customer, currentUser }: ICustomerInfoAwardReport) {
    var comp = Api_Config.getSelectedCompany();
    let token = Auth.getAuthToken();
    const [awardReport, setAwardReport] = React.useState<BidPeriodAwardReportInfo | undefined | null>(null);

    React.useEffect(() => {
        loadData();
    }, []);

    async function loadData() {
        ApiAwardReport.getAwardReport(customer.customerId).then(data => {
            setAwardReport(data);
        });
    }

    function renderAwardReport() {
        if (!awardReport) return renderNoAwardReport();
        var url = `${comp.adminApiUrl}/document/awddoc/${awardReport?.bidPeriodFileId}/${customer.customerId}?t=${token}`;
        return (
            <object data={url} type="application/pdf" width="100%" height="100%">
                <p><a href={url} target="_blank">View the Award Report here!</a></p>
            </object>
        )
    }

    function renderNoAwardReport() {
        return (
            <div>
                <span>No Award Report available for last Bid Period.</span>
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="container-fluid custawardreport-main">
                <div className="custawardreport-header" key={"awrpthdr" + awardReport?.bidPeriodFileId}>
                    <span className="custawardreport-bidmonth-label">Bid Month:</span><span className="custawardreport-bidmonth">{awardReport?.bidMonth || "None"}</span>
                </div>
                <div className="custawardreport-pdf" key={"awrptpdf" + awardReport?.bidPeriodFileId}>
                    {renderAwardReport()}
                </div>
            </div>
        </React.Fragment>
    )
}
